<template>
    <h2 class="heading" style="padding-left:90px;">Contract Agreement Details</h2>
    <div class="form">
        <el-form :model="contract" label-width="350px" style="width:1000px" >
            <el-form-item label="ID" required>
                {{contract.id}}
            </el-form-item>
            <el-form-item label="Nature" required>
                 {{contract.nature}}
            </el-form-item>

            <el-form-item label="Service" required>
                {{contract.service}}
            </el-form-item>

            <el-form-item label="Vendor Name" required>
                {{contract.vendorName}}
            </el-form-item>

            <el-form-item label="Related ETFs">
                {{ contract.relatedETFs ? contract.relatedETFs.replace(",", ", ") : ""}}
            </el-form-item>

            <el-form-item label="Launch Date" v-if="contract.launchDate">
                {{contract.launchDate}}
            </el-form-item>

            <el-form-item label="Agreement Date" required>
                {{contract.agreementDate}}
            </el-form-item>

            <el-form-item label="Effective Date" required>
                {{contract.effectiveDate}}
            </el-form-item>

            <el-form-item label="Next Renewal Date">
                {{contract.nextRenewalDate}} 
                <span class="tip" v-if="contract.renewDays && contract.renewDays >= 0">( <b style="color:#039">{{ contract.renewDays }}</b> days left )</span>
                <span class="tip" v-if="contract.renewDays && contract.renewDays <  0">( <b style="color:#D20">{{ -contract.renewDays }}</b> days overdue )</span>
            </el-form-item>

            <el-form-item label="Next Date to Cancel">
                {{contract.nextDateToCancel}}
                <span class="tip" v-if="contract.cancelDays && contract.cancelDays >= 0">( <b style="color:#039">{{ contract.cancelDays }}</b> days left )</span>
                <span class="tip" v-if="contract.cancelDays && contract.cancelDays <  0">( <b style="color:#D20">{{ -contract.cancelDays }}</b> days overdue )</span>
            </el-form-item>

            <el-form-item label="Initial Term">
                {{contract.initialTerm}}
            </el-form-item>

            <el-form-item label="Renewal Term">
                {{contract.renewalTerm}}
            </el-form-item>

            <el-form-item label="Notice Period for Termination">
                <span v-html="contract.noticePeriodForTermination"></span>
            </el-form-item>

            <el-form-item label="Fee Calculation">
                <span v-html="contract.feeCalculation"></span>
            </el-form-item>

            <el-form-item label="Fee per latest Bills">
                <span v-html="contract.feePerLatestBills"></span>
            </el-form-item>

            <el-form-item label="Contract Amount">
                {{global.number_format(contract.contractAmount, 2)}}
            </el-form-item>

            <el-form-item label="Billed Amount">
                {{global.number_format(contract.billedAmount, 2)}}
            </el-form-item>

            <el-form-item label="Currency" required>
                {{contract.currency}}
            </el-form-item>

            <el-form-item label="Billing Frequency">
                {{contract.billingFrequency}}
            </el-form-item>

            <el-form-item label="Due Within">
                {{contract.dueWithin}}
            </el-form-item>

            <el-form-item label="Overdue Penalty" v-if="contract.overduePenalty">
                {{contract.overduePenalty}}
            </el-form-item>

            <el-form-item label="Contact Person" v-if="contract.contactPerson">
                {{contract.contactPerson}}
            </el-form-item>

            <el-form-item label="Title" v-if="contract.title">
                {{contract.title}}
            </el-form-item>

            <el-form-item label="Email" v-if="contract.email">
                {{contract.email}}
            </el-form-item>

            <el-form-item label="Memo" v-if="contract.memo">
                {{contract.memo}}
            </el-form-item>
        </el-form>

        <div style="padding-left:350px;padding-top:10px;">
            <el-button onclick="history.back()">Back to list</el-button>
            <span class="errMsg" v-if="errMsg != ''">{{errMsg}}</span>
            <span v-if="loading" style="display:inline-block; margin-left:20px; vertical-align:middle;">
                <img src="@/assets/loading.gif" style="height:24px;"/>
            </span>
        </div>
    </div>
</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'

export default {
    data() {
        return {
            allETFs : ["2803", "3173", "3151", "3453", "3181", "2810",
                        "2804", "3077", "2817", "3001", "3411", "3478"], 
            allTerms: ["3 Months", "6 Months", "1 Year", "2 Years", "3 Years", "4 Years", "5 Years", "7 Years", "10 Years", "15 Years"],
            allCurrencies: ["HKD", "USD", "CNY", "EUR", "GBP", "JPY"],
            allFrequencies: ["Monthly", "Quarterly", "Annually"],
            etf : '',
            contract: {
                id: null,
                createTime: null,
                lastupdate: null,
                relatedETFs: "",
            },
            loading: false,
            files: '',
            errMsg: '',
            global,
        }
    },
    async mounted() {
        this.global.index = "contract";
        let code = this.$route.query ? this.$route.query.code : null;
        if (code) {
            let result = await AXIOS("/contract/getContract", {code: code});
            if (result.success) {
                this.contract = result.data;
                if (this.contract) {
                    this.contract.feeCalculation = this.contract.feeCalculation.replace(/\n/g, "<br/>").replace(/\r\n/g, "<br/>");
                    this.contract.noticePeriodForTermination = this.contract.noticePeriodForTermination.replace(/\n/g, "<br/>").replace(/\r\n/g, "<br/>");
                }
            } else {
                this.errMsg = result.errMsg;
            }
        }
    }
}
</script>

<style scoped>
    .heading {
        width:900px;
    }
    .errMsg {
        padding-left:10px;
    }
    .tip {
        background:#ff8; padding:0px 5px; font-size:14px;
    }
    .tip b {

    }
    .el-form-item {margin-bottom: 5px; }
    .el-form-item label {padding-right: 8px;}
    .el-form-item__content {padding-left: 8px;  color:#369; font-weight:bold; border-bottom: 1px solid #ccc;}
</style>